<div
  class="notification"
  [style.border-color]="borderColor"
  [style.background-color]="backgroundColor"
  [ngClass]="read ? 'isRead' : ''"
>
  <div class="icon">
    <i class="material-icons-outlined" [style.color]="iconColor">{{ icon }}</i>
  </div>
  <div class="content">
    <div class="header">
      <div class="left-column">
        <div class="title">{{ message.title }}</div>
        <div class="date text-hint">{{ date }}</div>
      </div>
      <div class="right-column">
        <button
          nbButton
          (click)="toggleReadStatus()"
          [nbTooltip]="read ? 'Mark as Unread' : 'Mark as Read'"
          style="padding: 0"
          ghost
        >
          <nb-icon icon="checkmark-circle-2" [status]="read ? 'success' : 'basic'"></nb-icon>
        </button>
      </div>
    </div>
    <div class="description" [innerHTML]="message.content"></div>

    @if (isDeleteBtnVisible) {
      <div class="delete-btn">
        <mat-icon
          fontIcon="hide_source"
          (click)="onDelete()"
          title="Hide Notification"
          class="text-hint"
        ></mat-icon>
      </div>
    }
  </div>
</div>
